import React from 'react';



export const TVTroubleshooting = ({ height="52px", width="36px",padding="12px",style=''})=> (
<svg className="icon_tv_outline" role="presentation" aria-label="" padding={padding} viewBox="0 0 26 21" version="1.1" xmlns="http://www.w3.org/2000/svg">
<g id="Symbols" stroke="none" strokeWidth="1" fill="rgb(97, 56, 245)" fillRule="evenodd">
<g>
<path d="M8,18.38h8v1.49H8ZM19,5.62H5a1.5,1.5,0,0,0-1.5,1.5v7A1.5,1.5,0,0,0,5,15.62H19a1.5,1.5,0,0,0,1.5-1.5v-7A1.5,1.5,0,0,0,19,5.62m0-1.5a3,3,0,0,1,3,3v7a3,3,0,0,1-3,3H5a3,3,0,0,1-3-3v-7a3,3,0,0,1,3-3Z"/>
</g>
</g>
</svg>
);
